import { useState } from 'react';
import { Table, Button, Modal } from 'antd';
import ReactJson from 'react18-json-view';
import { formatDate } from '../../../helpers/genericHelper';

function AdminChanges({ adminChanges = [] }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);

  const showModal = (record) => {
    setModalData(record);
    setModalVisible(true);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setModalData(null);
  };

  const columns = [
    { title: 'Admin', dataIndex: 'adminName' },
    { title: 'User ID', dataIndex: ['entry', 'userId'] },
    { title: 'Modification', dataIndex: ['entry', 'modification'] },
    { title: 'Url Path', dataIndex: ['entry', 'urlPath'],
      render: (text) => (
        <div style={{ wordBreak: 'break-all', whiteSpace: 'normal' }}>
          <span className="label" style={{ textDecoration: 'underline' }}>{text}</span>
        </div>
      )
    },
    { title: 'Data Body', dataIndex: 'body', width: 130,
      render: (_, record) => ( <Button onClick={() => showModal(record.entry)}>View Data</Button> )
    },
    { title: 'Time', dataIndex: ['entry', 'createTs'],
      render: text =>  formatDate(text, true)
     }
  ];

  return (
    <>
      <Table
        dataSource={adminChanges}
        columns={columns}
        rowKey="id"
        pagination={false}
      />
      <Modal
        title={modalData?.modification}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        open={modalVisible}
        onOk={handleModalCancel}
        onCancel={handleModalCancel}
        className="confirm-modal"
        width={800}
      >
        {modalData?.body && (
          <ReactJson src={JSON.parse(modalData.body)} />
        )}
      </Modal>
    </>
  );
}

export default AdminChanges;
